<template>
    <body class="">
        <!-- header -->
        <header id="header">
            <div class="container">
                <div class="nav">
                    <button class="btn btn-nav" @click="fn_gnbShow()">
                        <span class="blind">메뉴</span>
                    </button>
                    <button class="btn btn-back" @click="backbtn()">
                        <span class="blind">뒤로가기</span>
                    </button>
                </div>
                <div class="title">
                    <!-- <a ><img src="../assets/images/common/img_logo.png" alt=""></a> -->
                    <span>Face Mapping Registration</span>
                </div>
            </div>
        </header>
        <!-- // header -->

        <div id="content-wrap">
            <div id="contents">
                <!-- step info -->
                <div class="step-info-wrapper">
                    <div class="container tbm">
                        <ul>
                            <li @click="nextStep(data.tunnelConstructionMethod, 1)">
                                <span>STEP1.현장정보</span>
                            </li>
                            <li class="on" @click="nextStep(data.tunnelConstructionMethod, 3)">
                                <span>STEP2.사진대지</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- // step info -->
                <!-- gnb -->
                <gnb :gnb-on="gnbShow" @getChildGnbShow="getChildGnbShow" />
                <div class="gnb-dimmed" :class="gnbShow" @click="getChildGnbShow()" />
                <!-- // gnb -->

                <div class="pic-edit-wrapper">
                    <div class="pic-list-box tbm">
                        <ul>
                            <li>
                                <div class="pic-inbox">
                                    <div class="pic-header">
                                        <p class="pic-title">
                                            좌측면
                                        </p>
                                    </div>
                                    <div class="pic-body">
                                        <div class="image-box small">
                                            <div v-if="imageSrc[1] != null" class="photo-img">
                                                <img v-gallery:detail :src="imageSrc[1]" @error="imgError" />
                                                <button type="button" class="btn btn-pic-del" @click="imageDelete(1)">
                                                    <span class="blind">삭제</span>
                                                </button>
                                            </div>
                                            <label v-else for="photo-upload-2" @click="imageUpload(1)">
                                                <span class="blind">업로드</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="pic-inbox">
                                    <div class="pic-header">
                                        <p class="pic-title">
                                            우측면
                                        </p>
                                    </div>
                                    <div class="pic-body">
                                        <div class="image-box small">
                                            <div v-if="imageSrc[2] != null" class="photo-img">
                                                <img v-gallery:detail :src="imageSrc[2]" @error="imgError" />
                                                <button type="button" class="btn btn-pic-del" @click="imageDelete(2)">
                                                    <span class="blind">삭제</span>
                                                </button>
                                            </div>
                                            <label v-else for="photo-upload-3" @click="imageUpload(2)">
                                                <span class="blind">업로드</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div class="btn-wrapper bottom-fixed">
                        <button type="button" class="btn btn-cancel" @click="prev(data.tunnelConstructionMethod, 2)">
                            <span>이전으로</span>
                        </button>
                        <button type="button" class="btn btn-next" @click="save()">
                            <span>저장</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </body>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import FacemappingApi from '../api/FacemappingApi';
import FileApi from '../api/FileApi';
import { FILE_URL, NO_IMG, PICTURE_SORCE_TYPE } from '../const';
import CameraHelper from '../helper/CameraHelper';
import { photoDialog } from '../helper/DialogHelper';
import gnb from './layout/gnb.vue';
export default {
    name: 'Step3TBM',
    components: {
        gnb
    },
    data: () => {
        return {
            id: null,
            data: {
                id: null
            },
            gnbShow: '',
            imageFileIdMap: {},
            uploadFileIdx: null,
            imageSrc: {
                1: null,
                2: null
            },
            imageIds: {
                1: null,
                2: null
            }
        };
    },
    computed: {
        ...mapState({
            stateData: state => {
                return JSON.parse(JSON.stringify(state.facemapping.data));
            }
        })
    },
    beforeCreate() {
        ///////////////////////
        // Initializer Area
        ///////////////////////
        //this.showLoading();
        //this.$store.dispatch('showLoading');
    },
    created() {},
    mounted() {
        //ScreenHelper.setPortrait();
        window.scrollTo(0, 0);
        this.data = this.stateData;
        this.id = this.$route.params.id;
        if (this.id !== null) {
            this.dataObj();
        }
        this.hideLoading();
    },
    beforeDestroy() {},
    methods: {
        ...mapActions(['showLoading', 'hideLoading']),
        backbtn() {
            this.$router.go(-1);
        },
        imgError(e) {
            e.target.src = NO_IMG;
        },
        fn_gnbShow() {
            this.gnbShow = 'on';
            $('html').addClass('off');
        },
        getChildGnbShow() {
            this.gnbShow = '';
            $('html').removeClass('off');
        },
        nextStep(tunnelConstructionMethod, step) {
            if (step == 4) {
                this.$router.push({ path: `/step4/` + this.data.constructionName + `/${this.data.id}` });
            } else {
                this.$router.push({ path: `/step` + step + `/${this.data.id}` });
            }
        },
        prevStep() {
            this.$router.push({ path: `/step1/${this.id}` });
        },
        dataObj() {
            this.showLoading();
            FacemappingApi.detail(this.id).then(res => {
                this.data = res.content;
                this.imageSrc[1] =
                    this.data.tbmLeftImageOriginUrl != null ? FILE_URL + this.data.tbmLeftImageOriginUrl : null;
                this.imageSrc[2] =
                    this.data.tbmRightImageOriginUrl != null ? FILE_URL + this.data.tbmRightImageOriginUrl : null;

                this.imageIds[1] = this.data.tbmLeftImageOrigin;
                this.imageIds[2] = this.data.tbmRightImageOrigin;
                this.hideLoading();
            });
        },
        prev() {
            this.$router.go(-1);
        },
        save() {
            this.showLoading();
            this.data.tbmLeftImageOrigin = this.imageIds[1];
            this.data.tbmRightImageOrigin = this.imageIds[2];
            FacemappingApi.postImgTbm(this.data).then(() => {
                this.hideLoading();
                this.$router.push({ path: `/list` });
            });
        },
        imageUpload(idx) {
            this.uploadFileIdx = idx; //현재 이미지 위치
            photoDialog(this.btnCamera, this.btnGallery);
        },
        imageDelete(idx) {
            this.imageIds[idx] = null;
            this.imageSrc[idx] = null;
        },
        btnCamera() {
            CameraHelper.getPicture(PICTURE_SORCE_TYPE.CAMERA, this.cameraImage, err => {
                console.log('fail:' + err);
            });
        },
        btnGallery() {
            CameraHelper.getPicture(PICTURE_SORCE_TYPE.PHOTOLIBRARY, this.cameraImage, err => {
                console.log('fail:' + err);
            });
        },
        cameraImage(fileUrl) {
            const formData = new FormData();
            const now = new Date();
            const imageName = now.getTime() + '.jpg';

            this.imageSrc[this.uploadFileIdx] = fileUrl;

            formData.append('imgFile', CameraHelper.base64ToBlob(fileUrl), imageName);
            formData.append('file_id', '');
            this.showLoading();

            FileApi.imgUpload(formData).then(result => {
                this.imageIds[this.uploadFileIdx] = result.content.fileId;
                this.hideLoading();
            });
        }
    }
};
/*
#wrap > div {
    height: inherit;
}
*/
</script>
